import { SEARCH_CONTEXT } from '@/features/searchV2/constants/tracking';
import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { TabBase } from './types';

export const TabAction = (
  props: Pick<TabBase, 'id' | 'onClick' | 'to'> & { children: ReactNode; className: string },
) => {
  const location = useLocation();

  if (!props.to) {
    return (
      <button id={props.id} onClick={props.onClick} className={props.className}>
        {props.children}
      </button>
    );
  } else {
    if (props.to && props.to.startsWith('/')) {
      const hasQuery = props.to.includes('?');
      const [pathname, search] = hasQuery ? props.to.split('?') : [props.to, ''];

      return (
        <Link
          id={props.id}
          to={{
            pathname,
            search,
            state: { from: location.pathname, searchContext: SEARCH_CONTEXT.BOTTOM_NAVIGATION_BAR },
          }}
          onClick={props.onClick}
          className={props.className}>
          {props.children}
        </Link>
      );
    } else {
      return (
        <a id={props.id} href={props.to} onClick={props.onClick} className={props.className}>
          {props.children}
        </a>
      );
    }
  }
};
